/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {getUserData} from '@common'
import {UserRole} from '@enums'
import {getUserSelectionAtom} from '@state'

import {useQuery} from '@tanstack/react-query'
import {getDefaultStore} from 'jotai'

import {getAllDealers, getDealersByCompany, getDealerById} from './api'
import {dealerKeys} from './keys'
import {DealerResponse} from './types'

export const useDealers = () => {
  return useQuery<DealerResponse[], unknown>({
    queryKey: dealerKeys.lists(),
    queryFn: async () => {
      const currentUser = getUserData()
      const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
      const userSelection = userSelectionMap[currentUser.id]

      switch (currentUser.role) {
        case UserRole.SUPER_ADMIN:
          return getAllDealers()
        default:
          if (!userSelection?.companyId) return []
          return getDealersByCompany(userSelection.companyId)
      }
    },
  })
}

export const useDealersByCompany = (companyId?: string) => {
  return useQuery<DealerResponse[], unknown>({
    queryKey: dealerKeys.byCompany(companyId ?? ''),
    queryFn: () => getDealersByCompany(companyId ?? ''),
    enabled: !!companyId,
  })
}

export const useDealer = (id?: string) => {
  return useQuery<DealerResponse, unknown>({
    queryKey: dealerKeys.detail(id || ''),
    queryFn: () => getDealerById(id!),
    enabled: !!id,
  })
}
